import { render, staticRenderFns } from "./GoodsServiceManagement.vue?vue&type=template&id=64264406&scoped=true"
import script from "./GoodsServiceManagement.vue?vue&type=script&lang=js"
export * from "./GoodsServiceManagement.vue?vue&type=script&lang=js"
import style0 from "./GoodsServiceManagement.vue?vue&type=style&index=0&id=64264406&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64264406",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64264406')) {
      api.createRecord('64264406', component.options)
    } else {
      api.reload('64264406', component.options)
    }
    module.hot.accept("./GoodsServiceManagement.vue?vue&type=template&id=64264406&scoped=true", function () {
      api.rerender('64264406', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sinvoice_viettel/GoodsServiceManagement.vue"
export default component.exports